export default {
  common: {
    close: '閉じる',
    got: '閉じる',
    title: {
      email: 'メールアドレス'
    },
    cancel: 'キャンセル',
    clear: 'クリア',
    share: '共有',
    member: 'メンバー',
    settings: '設定',
    save: '保存',
    yes: 'はい',
    no: 'いいえ',
    done: '完了',
    name: '名前',
    loading: '読み込み中',
    back: '戻る',
    deleteConfirm: '削除しますか?',
    delete: '削除',
    rename: '名前を変更',
    empty: 'データがありません',
    inputhint: '入力してください',
    pre: '前へ',
    next: '次へ',
    beginning: '最後へ',
    last: '最後へ',
    forwardPage: ' ページ目へ',
    summary: '{n}件',
    ok: '確定',
    select: '選択',
    confirm: '確認',
    selectAll: 'すべて選択',
    all: 'すべて',
    minimize: '最小化',
    submit: '変更',
    action: 'アクション',
    active: '有効化',
    edit: '編集',
    move: '移動',
    remove: '削除',
    more: 'さらに表示',
    batch: '一括処理',
    MultiDelete: '一括削除',
    export: 'エクスポート',
    setDefault: 'デフォルトとして設定',
    create: '新規追加',
    fillin: '入力に進む',
    reset: 'リセット',
    other: 'その他',
    input: '入力してください',
    selectHint: '選択してください',
    uploadFile: 'ファイルのアップロード',
    uploadForm: 'アップロード',
    steps: '操作手順',
    import: 'インポート確認',
    download: 'ダウンロード',
    note: '備考',
    normalTip: 'ご注意',
    scanatId: 'Scanat ID',
    startTime: '開始日',
    endTime: '終了日',
    memberPermission: 'メンバー及び権限',
    page: {
      total: '総計{detail0}件',
      first: '最初のページ',
      previous: '前へ',
      next: '次へ',
      last: '最終ページ',
      go: '{detail0}ページ目へ',
      perPage: '件/ページ'
    }
  },
  mesh: {
    export: 'エクスポート',
    download: 'ダウンロード',
    all: '全データ',
    tip: 'モデルのすべてのデータを圧縮してエクスポートする',
    default: 'メッシュデータ',
    pointCloud: '点群データ',
    processing: '処理中',
    gltf: 'Android用',
    obj: '応用範囲が広い',
    stl: '3Dプリンター用'
  },
  week: {
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土',
    sun: '日'
  },
  month: {
    jan: '1月',
    feb: '2月',
    mar: '3月',
    apr: '4月',
    may: '5月',
    jun: '6月',
    jul: '7月',
    aug: '8月',
    sep: '9月',
    oct: '10月',
    nov: '11月',
    dec: '12月'
  },
  login: {
    passwordWrong: 'パスワードを確認してください。',
    accountUndefined: 'ユーザー名が存在しません。',
    verifiWrong: '認証コードが正しくありません。',
    verifiExpired: '認証コードの有効期限が切れています。',
    loginVerifiSent: '認証コードがメールに送信されました。',
    verifiSend: '認証コードを再度送信',
    login: 'ログイン',
    register: '登録 ',
    back: 'ログインはこちら',
    guideRegister: '新規アカウント登録はこちら',
    newAccount: '新規アカウント登録 ',
    email: 'メールアドレス',
    password: 'パスワード',
    forgetPassword: 'パスワードをお忘れの方',
    emailError: 'メールアドレスのフォーマットが正しくありません。',
    passwordTip: 'パスワードは10文字以上50文字以下で、半角英字と数字をそれぞれ1文字以上含めて設定してください。',
    emailNone: 'このメールアドレスは登録されていません。',
    accountError: 'ユーザー名とパスワードを確認してください。',
    resetPasswordSent: 'パスワードを再設定するためのメールを送信しました。',
    verifiSent: '認証コードをメールに送信しました。',
    passwordConfirm: 'パスワードの確認',
    send: '送信 ',
    sent: '認証コードを送信しました。',
    verify: '認証コード',
    inputVerify: 'メールに届いた6桁の認証コードを入力してください',
    resetPassword: 'パスワードをリセット',
    noEmpty: 'すべての必須項目に入力してください。',
    verifyFormat: '認証コードは6桁で入力してください。',
    verifyNumber: '認証コードは6桁の数字で入力してください。',
    checkPassword: 'パスワードを確認してください',
    resetPasswordSuccess: 'パスワードを再設定しました。',
    existUser: 'このユーザーは既に存在しています。',
    loginSuccess: 'ログインしました。',
    registerSuccess: '登録が完了しました。',
    logout: 'ログアウト',
    terms: '<link>Scanatの利用規約</link> に同意します',
    termsError: '利用規約の内容をご確認のうえ、同意いただける場合のみチェックして登録を進めてください。',
    alert: {
      title: 'ご注意',
      info: 'パスワードリセット用のリンクを記載したメールをお送りしました。'
    },
    invalid: {
      info: 'このパスワードリセット用リンクは無効です。',
      tip: 'パスワードリセット用のリンクを、もう一度取得してください。'
    },
    noExist: {
      info: 'リンクが見つかりません。',
      tip: 'リンクが正しいかご確認ください。'
    },
    go: '次へ',
    forgetPasswordToast: 'リクエストが集中しています。1分後に再度お試しください。',
    introduction: '空間をデジタル化する、未来を創造する',
    verifyText: '認証コード'
  },
  error: {
    connectionOut: '接続がタイムアウトしました。\\n\nネットワーク接続を確認するか、しばらくしてから再試行してください。',
    server: 'サーバーが過負荷状態かメンテナンス中です。しばらくしてから再試行してください。',
    connectionCheck: 'ネットワーク接続を確認してください。',
    invalidAccount: '該当アカウントが無効です。管理者にお問い合わせください。',
    contactManage: 'アクセス権限がありません。管理者にお問い合わせください。',
    noPlan: 'プランを契約していないため、このサービスはご利用できません。',
    overDate: 'ご契約プラン{plan}は{date}に期限切れとなったため、このサービスを使用いただけません。',
    unactive: 'ご契約プラン{plan}は{date}から有効になります。プラン開始後にアクセスしてください。',
    needLevelUp: '御社は現在、このサービスを利用するプランにご加入いただいておりません。',
    noService: '御社は現在、このサービスを購入されておりません。アクセスできません。',
    emptyName: '姓または名は入力してください。',
    unsaveEdit: '編集中の内容を保存してください。',
    overSeat: 'ID数の上限に達しましたので、メンバーを追加できません。一部のメンバーを削除するか、ID数の追加を行ってください。',
    overSeatActivation: 'ID数の上限に達しましたので、メンバーを有効化できません。一部のメンバーを削除するか、ID数の追加を行ってください。',
    noSelectMember: '削除対象のメンバーを下記から選択してください。',
    bestPlan: '現在ご契約中のプランは最上位版のため、アップグレードできません。',
    noPermission: '権限がありません。',
    emailEmpty: '{n}行目のメールアドレスが未入力です。入力後に再度アップロードしてください。',
    nameExceed: '{n}行目の姓または名は10文字を超えることはできません。修正後に再度アップロードしてください。',
    importExceed: '一度にインポートできるメンバーは100名までです。ファイル内の一部メンバーを削除してから再度アップロードしてください。',
    comInfoAction: '会社情報の入力',
    comInfoModal: '会社情報が未完成です。会社情報を入力してください。',
    comInfoBuy: '会社情報を先に入力してから、購入手続きを行ってください。',
    comInfoHome: 'ご注意：会社情報が未完成の場合、一部の機能がご利用いただけない場合があります。',
    usedAccount: 'このアカウントはすでに他の会社に登録されているため、追加できません。再度ご入力ください。',
    existCompany: 'このアカウントは既に会社に追加済みです。重複して追加することはできません。',
    wrongEmail: '正しい郵便番号を入力してください。',
    unsavePage: '現在のページ内容を先に保存してください',
    repetitiveMail: '表の中に重複するメールアドレスがあります。確認して再度アップロードしてください。',
    otherMember: 'メールアドレス {email}はすでに登録されています。ご確認の上、再度アップロードしてください。',
    wrongFormat: 'メールアドレス {email} の形式が正しくありません。修正して再度アップロードしてください。',
    creditExpired: 'クレジットカードの有効期限が切れています。有効期限をご確認いただくか、別のカードをご利用ください',
    agreement: '利用規約に同意してください。',
    creditDisable: 'クレジットカードがご利用いただけません。ご確認の上、再度ご入力ください。',
    payFailed: '支払いに失敗しました。クレジットカードが正常に使用できるかご確認ください。',
    noAccess: 'このページにアクセスできません。',
    code: {
      '403': 'アクセスが拒否されました',
      '404': 'ページが見つかりません',
      '500': 'サーバーが過負荷状態メンテナンス中です。しばらくしてから再試行してください。',
      '502': 'サーバーが混雑しています。しばらくしてから再試行してください。',
      '504': 'サーバーが混雑しています。しばらくしてから再試行してください。'
    },
    oneDevice: 'セキュリティ上の理由で、Scanat Webでは複数端末からの同時ログインはできません。アカウントが自動的にログアウトされました。再度ログインしてください。',
    overDue: 'セッションの有効期限が切れました。再度ログインしてください。',
    checkNetWork: 'ネットワーク接続を確認してください。',
    timeOut: '接続がタイムアウトしました。ネットワーク接続を確認するか、しばらくしてから再試行してください。',
    noCompanyInfo: '企業情報がまだ入力してないです。企業情報メニューバーで企業情報を完全に入力した後に、プランの購入が可能です。',
    accountDisable: 'このアカウントが無効化されているため、アクセスできません。',
    noSeat: 'このアカウントは「Scanatサービス利用」の設定がオフのため、アプリをご利用いただけません。',
    noRight: '該当アカウントには、このサービスへのアクセス権限がありません。',
    comInfoDomain: '会社情報を入力してから、ドメインを追加してください。',
    accountNoAccess: 'このアカウントは無効化されているため、ログインできません。',
    existName: 'この名前は既に存在します。別の名前に変更してください。',
    nameTooLong: 'モデル名を20文字以内で入力してから再度アップロードしてください。',
    noModel: 'モデルデータがありません。'
  },
  complete: {
    save: '保存が完了しました',
    export: 'エクスポートが完了しました',
    replace: '更新しました',
    setManagement: '管理者の設定が完了しました',
    cancelSetManag: '管理者の解除が完了しました',
    card: 'クレジットカードが追加されました',
    cardUpdate: 'クレジットカードが更新されました',
    cardDeleted: 'クレジットカードが削除されました',
    importMember: '取り込みが完了しました',
    invoiceDown: '領収書のダウンロードが完了しました',
    diagramDown: '図面のダウンロードが完了しました',
    invoiceSent: '請求書の送信が完了しました',
    add: '追加しました',
    change: '編集しました',
    delete: '削除しました',
    bought: 'お申し込みいただきありがとうございます。'
  },
  landing: {
    select: '利用するサービスを選択',
    idManage: 'ID管理',
    scanatWeb: 'Scanat Web',
    pwChange: 'パスワードを更新',
    logout: 'ログアウト',
    tipId: '· アカウント管理\n（ステータスの更新・管理権限の切り替え等）\n· プランの購入\n· 請求書と領収書のダウンロード',
    tipScanat: '· 全社と個人のクラウドデータ管理\n（個人フォルダの作成等）\n· PCブラウザでのモデル操作と計測データ編集\n· 社内ユーザと同時にモデルの閲覧と計測データ編集',
    alertNoPlan: 'Scanat Webは法人プラン（Plan B以上）のオプション機能です。 アプリでスキャンしたモデルをブラウザ上で閲覧・操作でき、モデルリンクを作成してScanatユーザ以外にも共有できる便利な機能です。\n\n詳細は<link>お問い合わせフォーム</link>、または営業担当までお問い合わせください。',
    invalidAccount: 'アカウントが無効のため、Scanat Webを利用できません。',
    unnamed: '名前空白'
  },
  file: {
    allFile: 'ホームリスト',
    sample: 'サンプルモデル',
    modelAmount: 'モデル数',
    newFolder: '新規フォルダ',
    fileName: 'ファイル名\n',
    owner: '所有者',
    time: 'アップロード日時',
    createTime: '作成日時',
    scanner: '撮影者',
    scanTime: '撮影日時',
    editor: '最終更新者',
    updateTime: '更新日時',
    dataSize: 'データ容量',
    folder: 'フォルダ',
    fileAmount: '{n} 項目のモデル',
    shareString: '{ID} より {time} に共有',
    createString: '{time} に作成\n',
    uploadString: '{time} にアップロード',
    updateString: '{time} に更新',
    editorString: '{ID} より{time} に更新',
    filter: '絞り込み',
    sort: '並べ替え',
    restore: 'リセット',
    all: 'すべて',
    filterStatus: 'モデル状態',
    filterCad: 'CAD図面依頼済み',
    filterMark: 'ピンの状態',
    filterMarked: 'ピンあり',
    fiterOwner: '所有者',
    filterSelfOwner: '自分',
    filterShared: '共有されたもの',
    updateNewest: '更新の新しい順',
    createNewest: 'アップロード/作成の新しい順',
    searchHint: 'キーワードを入力',
    pagePre: '前へ',
    pageNext: '次へ',
    pageFirst: '最初へ',
    pageLast: '最後へ',
    operate: '操作',
    share: '共有',
    selectAll: 'すべて選択',
    rename: '名前の変更',
    moveTo: 'フォルダに移動',
    tipSample: 'まだアップロードされたモデルデータはありません。Scanatアプリからモデルをアップロードするか、サンプルモデルを開き、実際の操作感をお確かめください。',
    btnSample: 'サンプルモデルを開く',
    noFile: 'このフォルダにはデータがありません。',
    noResult: '結果が見つかりませんでした。キーワードを変更するか、入力内容を確認するか、フィルター設定を調整してください。',
    noResultTitle: '何も見つかりませんでした',
    noSearchResult: 'キーワードの変更、入力ミスのチェック、またはフィルターの調整を試してみることをおすすめします。',
    id: {
      log: '顧客操作ログ',
      logCompany: '{company}操作ログ',
      transactionFiles: '証憑書類{number}',
      memberList: 'メンバーリスト{YYYYMMDD}',
      planOrderList: 'プラン注文リスト{YYYYMMDD}',
      cadOrderList: 'CAD注文リスト{YYYYMMDD}',
      customerInformationList: '顧客情報リスト{YYYYMMDD}',
      companyMemberList: '{company}メンバーリスト{YYYYMMDD}',
      accountList: 'アカウントリスト{YYYYMMDD}',
      userBatchImportTemplate: 'ユーザー一括インポートテンプレート',
      invoice: '請求書{number}'
    },
    code: {
      get: '埋め込みコードを取得',
      mode: '読み込み方法',
      manual: '手動読み込み',
      auto: '自動読み込み',
      copy: '埋め込みコードをコピー',
      language: '表示言語',
      copySuccess: 'コードがコピーされました。'
    },
    delete: {
      title: 'このモデルを削除しますか？',
      prompt: '削除後、モデルの権限を持っているメンバーは、これらのモデルにアクセスできなくなります。',
      noAuth: '削除権限がないファイルを含みます。選択し直してください。'
    },
    deleteFolder: {
      title: 'このフォルダを削除しますか？',
      prompt: '削除後は、あなたと他のメンバーは選択したフォルダ内のモデルにアクセスできなくなります。'
    },
    mark: {
      cancledToast: 'ピンなし',
      markedToast: 'ピンあり'
    },
    copy: 'コピー',
    import: {
      button: 'モデルインポート',
      title: 'モデルインポート',
      tip1: '3Dファイルを選択またはここにドロップしてインポートしてください。',
      tip2: '対応形式',
      tip3: '最大500MBまで、テクスチャを含む場合は、ZIP形式で圧縮の上、インポートしてください。',
      select: 'ファイルを選択',
      reSelect: 'ファイルを再選択',
      release: 'ドロップしてファイルをインポート',
      refresh: 'インポート中です。ページを再読み込みしたり閉じたりしないでください。中断するとインポートができなくなります。',
      fail: 'インポートできませんでした。再度試してください。',
      prompt: 'インポート中です。ページを再読み込みするとインポートができなくなりますが、よろしいですか？',
      error: {
        checkNet: 'インポートできませんでした。ネットワークを確認してから再度試してください。',
        parsingFailed: 'モデルの解析ができませんでした。ファイルを確認してから再度試してください。',
        system: '処理中にエラーが発生しました。暫くしてから再度試してください。',
        invalidFile: 'ZIPファイル内に有効なモデルデータが見つかりませんでした。ファイルを確認してから再度試してください。'
      }
    },
    itemsPerPage: '表示件数',
    teamSpace: 'チームスペース',
    mySpace: '個人スペース',
    editFolder: 'フォルダを編集',
    folderName: 'フォルダ名',
    folderNameHint: 'フォルダ名を入力してください。',
    folderDesc: '備考',
    folderDescHint: '備考があれば記入してください。',
    folderEmptyDesc: '備考はありません。',
    editModel: 'モデル名を変更',
    modelName: 'モデル名',
    modelNameHint: 'モデル名を入力してください。',
    sortBy: {
      updateTimeDescending: '更新日時（降順）',
      updateTimeAscending: '更新日時（昇順）',
      createTimeDescending: '作成日時（降順）',
      createTimeAscending: '作成日時（昇順）',
      firstletterDescending: '名前（A → Z）',
      sizeDesc: 'サイズ（降順）',
      sizeAsc: 'サイズ（昇順）'
    },
    creator: '作成者',
    createOrUploadTime: 'アップロード日',
    noFound: {
      text: '「{0}」のフォルダは見つかりませんでした。別のキーワードを試してください。'
    },
    move: {
      noAuth: '移動権限がないファイルを含みます。選択し直してください。'
    },
    modelNum: '{n} 件のモデル'
  },
  filemodal: {
    deletAll: '削除しますか？\n',
    selectMove: '移動先を選択',
    move: '確認',
    noData: 'データがありません',
    share: 'Web用リンクの共有',
    copyLink: 'リンクをコピー',
    copySuccess: 'リンクをコピーしました。',
    shareTip: '1. Scanat Webの権限があるユーザ：モデルを閲覧および編集できます。変更は共有元モデルにリアルタイムで同期されます。\\n\n2. Scanat Webの権限がないユーザ：モデルを閲覧および編集できますが、変更は共有元モデルには適用または保存されません。',
    moveSuccess: '移動しました。',
    folderSuccess: 'フォルダを作成しました。',
    changeSuccess: '変更しました。',
    noSpecialSymbol: '特殊文字は使用できません。',
    resetLink: 'リンクをリセットしますか？ リセットすると、現在のリンクはアクセスできなくなります。',
    moveFileTitle: 'ファイルを移動',
    moveFolderTitle: 'フォルダを移動',
    moveModelTitle: 'モデルを移動',
    sharePromptOld: ' 1. ScanatWeb権限をお持ちの方：同時にモデルの閲覧と編集が可能\n 2. ScanatWeb権限をお持ちでない方：モデルの閲覧は可能だが、同時編集は不可 ',
    moveFileDesc: '移動されたファイルは宛先フォルダの権限設定に従います。また現在の協働メンバーがファイルにアクセスできなくなる可能性があります。',
    moveFolderDesc: '移動されたフォルダは宛先フォルダの権限設定に従います。また現在の協働メンバーがフォルダにアクセスできなくなる可能性があります。',
    moveModelDesc: '移動されたモデルは宛先フォルダの権限設定に従います。また現在の協働メンバーがモデルにアクセスできなくなる可能性があります。',
    deleteComfirm: '削除後は復元できません。削除しますか？',
    cannotEdit: 'このファイルは削除済みのため、編集できません。',
    cannotAccess: 'このファイルは削除されました。アクセスできません。'
  },
  toast: {
    noMovePermission: '宛先フォルダへの移動権限がありません。他の宛先を選択してください。',
    exist: '既に宛先に存在します。',
    cannotMove: 'このフォルダやサブフォルダへの移動ができません。',
    depth: {
      exceed: 'フォルダ階層の上限を超えています。別のフォルダを選択してください。'
    }
  },
  share: {
    accountShare: 'アカウントで共有',
    linkShare: 'リンクで共有',
    searchHint: '連絡先のアカウントを入力して検索',
    searchEmpty: '該当する連絡先が見つかりません。\n他のキーワードで検索してください。',
    people_amount: '{n}人',
    read: '閲覧のみ',
    edit: '編集可能',
    manage: '管理可能',
    resetLink: 'リンクをリセット',
    overwritePw: '現在のパスワードを上書き',
    limits: '権限',
    unSaveTip: '先にパスワードを保存またはキャンセルしてください',
    title: {
      privateLink: 'プライベートリンク',
      encryptedLink: 'パスワード付きリンク',
      publicLink: '公開リンク',
      changeLinkPassword: 'リンクパスワードの変更'
    },
    desc: {
      privateLink: '・チームメンバーのみアクセス可能',
      encryptedLink: '・パスワードを知っている人がアクセス可能',
      publicLink: '・誰でもアクセス可能'
    },
    hint: {
      changeLinkPassword: '4〜20文字の数字またはアルファベットで入力してください。'
    },
    toast: {
      changeModeSuccess: '権限設定が完了しました。',
      noPermission: 'モデルの所有者と管理者のみ変更可能です。',
      save: '先にパスワードを保存またはキャンセルしてください。',
      noPermissionNew: 'モデルの編集権限、又は管理権限が必要です。'
    },
    alert: {
      title: {
        changeToPublic: 'ご注意'
      },
      info: {
        changeToPublic: 'この機能を有効にすると、インターネット上でリンクを知っている人なら誰でもモデルにアクセスできます。'
      }
    },
    copy: 'Web用リンクをコピーしました。入力ボックスに貼り付けて他の人に共有できます。',
    link1: '{detail0}',
    link2: 'Scanatのモデルリンク：{detail0}\nパスワード：{detail1}',
    copyLink: 'リンクをコピー',
    modelNotFound: 'モデル「{modelName}」が削除されました。',
    link: {
      noModel: 'モデルが見つかりません。',
      noModelTip: 'リンクが正しいか、再度ご確認ください。'
    },
    privateLink: {
      linkFail: 'リンクが無効になりました。',
      tip: '現在ログイン中のアカウントは 「{id}」です。新しいリンクを取得するには「{admin_id}」 にお問い合わせください。',
      contactManage: 'アクセス権限がありません。管理者にお問い合わせください。',
      limitPermission: '現在ログイン中のアカウントは 「{id}」で、モデルへのアクセス権限がありません。'
    },
    encryptedLink: {
      needPassword: 'このモデルにアクセスするにはパスワードが必要です。',
      errorPassword: '正しいパスワードを入力してください。',
      go: '次へ',
      placeholder: 'パスワードを入力してください。'
    }
  },
  member: {
    searchHint: 'アカウントを入力して検索',
    searchEmpty: '該当メンバーが見つかりません。別のキーワードで試してください。',
    addMember: '協働メンバーを追加',
    owner: '所有者',
    admin: 'スーパー管理者',
    outsider: '社外メンバー'
  },
  import: {
    model: 'モデルインポート',
    fail: 'インポートできませんでした。',
    reimport: 'モデルを再インポート',
    importGuide: '3Dファイルを選択またはここにドロップしてインポートしてください。',
    importFormat: '対応形式：OBJ/GLTF/GLB/DRC/STL/PLY/DAE/FBX/SKP/USDZ/DXF/ZIP\nテクスチャを含む場合は、ZIP形式で圧縮の上、インポートしてください。',
    releaseMouse: 'ドロップしてファイルをインポート',
    localFile: 'ファイルを選択',
    reSelect: 'ファイルを再選択',
    wrongFormat: '選択されたファイル形式は対応されていません。別のファイルを選択してください。',
    fileSizeLimit: 'ファイルサイズが上限を超えています。'
  },
  language: {
    ja: '日本語',
    en: 'English',
    cn: '简体中文'
  },
  profile: {
    basic: '基本情報',
    account: 'アカウント',
    name: '氏名',
    company: '所属会社',
    superManage: 'スーパー管理者',
    manage: '管理者',
    member: '通常メンバー',
    deregisterAccount: 'アカウント削除',
    deregisterTip: '1.あなたの個人情報や履歴は復元できません。\\n\n2. すべてのモデル記録や取引記録は削除され、復元できません。\\n\n3. あなたがスーパー管理者で、まだ削除されていないアカウントがチームに存在する場合、ログアウトすることはできません。',
    deregisterWarningCo: 'アカウント削除すると、企業のすべてのモデル記録が削除され、復元することはできません。',
    deregisterWarningUser: 'アカウント削除すると、あなたのすべてのモデル記録が削除され、復元することはできません。',
    deregisterConfirm: 'アカウント削除の確認',
    deregisterfail1: 'チームにはまだ',
    deregisterfail2: 'アカウント',
    deregisterfail3: 'が使用してます。招待状の管理ページに移動して、該当するメンバーを削除してから再度アカウント削除してください。',
    deregisterComplete: 'アカウント削除が完了しました',
    continue: 'アカウント削除を続ける',
    manageAccount: 'アカウントを管理する'
  },
  company: {
    setting: '会社情報',
    basic: '基本情報',
    expand: '拡張情報',
    name: '会社名',
    nameInput: '会社名を入力してください',
    owner: '主担当者',
    ownerNameTitle: '氏名',
    ownerGenderTitle: '性別',
    ownerPhoneTitle: '電話番号',
    ownerLastname: '姓',
    ownerName: '名',
    ownerSexual: '性別',
    ownerMale: '男',
    ownerFemale: '女',
    numberInput: '電話番号を入力してください',
    zipcode: '郵便番号',
    zipcodeInput: '郵便番号を入力してください',
    address: '住所',
    addressProvince: '都道府県',
    addressCity: '市区町村',
    addressDistrict: '町名番地',
    addressDetails: 'それ以降の住所',
    industry: '所属業種',
    industrySelect: '所属業種を選択してください',
    industryArchi: '建設業',
    industryManu: '製造業',
    industryEstate: '不動産業，物品賃貸業',
    industryTel: '情報通信業',
    industryElectric: '電気・ガス・熱供給・水道業',
    industryTrans: '運輸業，郵便業',
    industryInfo: '情報処理サービス業',
    industryStudy: '学術研究，専門・技術サービス業',
    industryRetail: '卸売業，小売業',
    industryResearch: 'リサーチ業',
    scale: '従業員数',
    scaleSmall: '50名以下',
    scaleMedium: '50-100名',
    scaleLarge: '100名以上',
    scaleSelect: '従業員数を選択してください',
    capital: '資本金',
    capitalInput: '資本金を入力してください',
    capitalUnit: '円',
    service: '事業内容',
    serviceInput: '事業内容を入力してください',
    domainManage: 'ドメイン管理',
    domainList: 'ドメイン一覧',
    domainDesc: 'Scanat Webでは、モデル詳細画面を外部サイトに埋め込むことができます。ここで外部サイトのドメインを追加すると、埋め込みコードは登録したドメインでのみ有効になります。最大10個のドメインを登録できます。',
    domain: 'ドメイン',
    addDomain: 'ドメインの追加',
    editDomain: 'ドメインの編集',
    deleteDomain: 'ドメインの削除',
    inputDomain: 'ドメインを入力してください',
    domainError: '有効なドメインを入力してください',
    deleteDomainTip: 'このドメインを削除してもよろしいですか？削除すると、このドメインでモデル埋め込みコードが使用できなくなります。',
    inputCorrectPhone: '有効な電話番号をご入力ください',
    inputNumber: '数値をご入力してください',
    domainIframeError: 'このドメインは認可されていないので、表示できません。',
    DomainExsit: 'このドメインは既に使われているので、別のドメインを入力してください。'
  },
  card: {
    manage: 'クレジットカード管理',
    number: 'カード番号',
    dueDate: '期限満了日',
    status: '状態',
    owner: 'カード名義人',
    statusNormal: '利用可能',
    statusExpired: '期限切れ',
    default: 'デフォルトのクレジットカード',
    bind: '決済用クレジットカード',
    setDefault: 'デフォルトとして設定',
    create: '新しいクレジットカードを登録',
    inputNumber: 'カード番号を入力してください',
    validity: '有効期限',
    inputMonth: '月を入力してください',
    inputYear: '2桁の年を入力してください',
    securityCode: 'セキュリティコード',
    inputSecurityCode: 'セキュリティコードを入力してください',
    inputOwner: 'カード名義人の名前を入力してください',
    errorNumber: '16桁の整数を入力してください',
    errorMonth: '1月から12月の中から選んで入力してください',
    errorYear: '有効な年を入力してください',
    errorSecurity: 'セキュリティコードを入力してください',
    errorOwner: 'カード名義人を記入してください',
    errorExpired: 'このクレジットカードの有効期限が切れています。期限を確認するか、新しいカードに切り替えてください',
    delete: 'クレジットカードの情報を削除',
    deleteConfirm: '末尾が{number}のクレジットカードを本当に削除してもよろしいですか？',
    deleteComplete: 'クレジットカードの情報が削除されました',
    defaultComplete: 'デフォルトとして設定されました',
    emptyTitle: 'クレジットカード情報が未登録です',
    emptyDesc: '下のボタンをクリックして、クレジットカードを登録してください',
    inputMonthYear: 'MM/YY',
    error: {
      InvalidNumber: '入力されたカード番号が無効です。',
      tooShortNumber: '入力されたカード番号に不備があります。',
      invalidDate: '入力されたカードの有効期限は無効です。',
      incompleteDate: '入力されたカードの有効期限に不備があります。',
      expiredDate: '入力されたカードの有効期限は過去の日付です。',
      invalidSecurityCode: '入力されたカードのセキュリティコードに不備があります。'
    }
  },
  home: {
    title: 'ホーム',
    modelAmount: 'モデルの総数（個）',
    memberAmount: 'メンバーの数（名）',
    orderAmount: '生成された注文数（件）',
    quick: 'ショートカットリンク',
    completeInfo: '会社情報の更新',
    team: 'チームを構築',
    cowork: 'モデルコラボレーション',
    order: '注文履歴を確認する',
    read: '初心者必読',
    back: 'ホーム画面に戻る'
  },
  plan: {
    a: 'Plan A スターター',
    b: 'Plan B ベーシック',
    bApp: 'Plan B ベーシック（アプリ版）',
    bAll: 'Plan B ベーシック（アプリ版 + Web版）',
    c: 'Plan C ビジネス',
    selectPlan: 'プランの選択',
    planDetail: 'プラン詳細',
    id: 'ご利用可能なID数',
    idMoreThan: '以上',
    app: 'アプリ版',
    appWeb: 'アプリ版 + Web版',
    price: '{price}円～',
    none: '現在ご契約中のプランはありません',
    now: '現在ご契約中のプラン',
    statusActive: '契約中',
    statusUnactive: '開始前',
    end: '終了',
    aYearText: '月払いと比較して 24,000 円お得',
    unSelected: '選択中のプランはありません。'
  },
  order: {
    list: '取引履歴',
    plan: 'プラン注文',
    cad: 'CAD注文',
    statusUnpay: 'お支払い待ち',
    trial: '先行トライアル可能',
    statusPaid: 'お支払い済み',
    statusCancel: 'キャンセル済み',
    statusComplete: '処理済み',
    statusProcessing: '処理中',
    searchHint: '管理番号/プラン名を入力して検索',
    number: '管理番号',
    name: 'プラン名',
    payMethod: 'サブスクリプション形式',
    payMonth: '月払い',
    payYear: '年払い',
    switchPayMethod: 'サブスクリプション形式の変更',
    switchPay: 'サブスクリプション形式の変更',
    switchMonthTip: 'プランAのサブスクリプション形式を【月払い】に変更しますか？',
    switchYearTip: 'プランAのサブスクリプション形式を【年払い】に変更しますか？',
    currentPeriod: '現在プランの有効期限',
    nextPeriod: '次回プランの有効期限',
    currentSeat: '現在ご契約中のID数',
    periord: 'ご契約期間',
    selectSeat: 'ご利用希望のID数',
    seat: 'ご契約ID数',
    seatAdded: '新規でご利用可能なID',
    seatAddSum: '追加希望の新規ID数',
    seatAddTime: 'ご利用開始日',
    selectTime: '日付を選択してください',
    seatPeople: '{n}人',
    seatUnactive: '{n}個のIDが有効化待ち',
    seatTip: 'ここで選択したID数は、チームで利用可能なIDの合計となります。（例：10を選択した場合、チーム全体で利用可能なID数は10となります）',
    packageCount: 'パッケージ数',
    packageCountTip: '購入するパッケージ数を選択してください',
    additionalIdCount: '追加ID数',
    additionalIdCountTip: 'パッケージの基本ID数に加えて追加購入するID数',
    totalIdCount: '合計{count}個のID',
    packageBaseIdCount: '選択したパッケージには{count}個のIDが含まれています',
    seatOver: 'メンバー数が上限を超えました',
    seatOverTip: '現在チームのメンバーは{n}人です。{n}ID以上のプランをご契約いただくか、管理画面で一部のメンバーを削除してからご契約ください。',
    memberUsed: '現在利用中のID数',
    deleteMemble: 'メンバーを削除する',
    cancelTip: '{date}キャンセル',
    expandSeat: 'ID数追加',
    purchase: 'プランを申し込む',
    purchaseNow: '今すぐ契約',
    levelUp: 'アップグレード',
    renewal: '契約更新',
    buy: '新規契約',
    changeTime: '利用期間を変更',
    olderTime: '現在の利用期間',
    newTime: '更新後の利用期間',
    startTime: '利用開始日',
    endTime: '利用終了日',
    updateTime: 'アップグレード日',
    contactService: 'サポート・問い合わせ',
    changeCard: 'お支払いのクレジットカードを変更',
    SelectCard: 'お支払いのクレジットカードを選択してください',
    cancel: 'プラン解約申請',
    cancelTip1: 'プランを解約すると、プランは{date}に終了し、それ以降は自動更新されません。その際、メンバー全員がシステムを利用できなくなります。本当に解約してよろしいですか？',
    cancelTip2: 'プランを解約すると、契約の自動更新が停止されます。契約終了後、メンバー全員がシステムを利用できなくなります。本当に解約してよろしいですか？',
    revokeCancellation: '解約を取り消す',
    revokeTip: '解約を取り消しますか？取り消した場合、再度解約が可能です。',
    seatExpandExceed: '現在ご契約中のプランでの上限は{max-seat}IDです。既に{exist-seat}席を利用中のため、追加できるのは{left-seat}IDまでです。ID数を調整して再度送信してください。',
    unpaidTip: '現在、お支払い待ちのご注文がございます。お支払い手続きへお進みいただくか、サービス提供側にご連絡ください。',
    noPlanError: '現在、ご契約のプランがないため、新規IDを追加できません。サービス提供側にご連絡いただき、一度ご注文をキャンセルしてから改めてプランをご購入ください。',
    existPlantip: '{plan}プランをすでにご契約中のため、新規プランをご契約いただけません。',
    unactivePlantip: '{plan}プランをご契約済みです。サービス開始日{date}からご利用いただけますので、今しばらくお待ちください。',
    noPlan: '現在利用可能なプランはありません',
    newPlan: '変更後のプラン',
    learn: 'プランの詳細',
    learnMore: 'プランの詳細を確認',
    checkCurrentPlan: '現在ご契約中のプランを確認',
    confirmOrder: 'プランを選択して申し込む',
    orderInfo: 'お申し込み内容',
    planStart: 'ご利用開始日',
    planStartInstant: 'お支払いが完了次第',
    item: '注文内容',
    itemName: '商品名',
    modelName: 'モデル名',
    diagramType: '図面種別',
    category: '種別',
    totalItem: '数量',
    unitPriceYen: '単価',
    totalSumYen: '小計',
    unitPrice: '単価',
    totalSum: '小計',
    unusedSum: '未使用のパッケージ残高',
    quickSum: '合計',
    tax: '消費税（10%）',
    payableSum: 'お支払い金額',
    payableSumUnit: 'お支払い金額（円）',
    submit: 'この内容で申し込む',
    confirmSubmit: 'この内容で申し込む',
    createUser: '操作ID',
    createTime: '操作日時',
    paidTime: 'お支払い日時',
    giveTime: '納品日時',
    paidStatus: 'お支払い状況',
    cadStatus: 'CAD作成状況',
    orderSum: '支払金額',
    status: 'お支払い状況',
    leftTime: '支払期限まであと',
    leftDay: '日',
    leftHr: '時間',
    leftMin: '分',
    leftSec: '秒',
    expireTip: 'ご注意：支払期限までにお支払いされなかった場合、お申し込みは自動的にキャンセルされます。',
    purchaseSuccess: 'お申し込みいただきありがとうございます。',
    switchTipYear: '{date} に年額契約に切り替わります',
    switchTipMonth: '{date} に月額契約に切り替わります',
    autoFail: '自動引き落としに失敗しました',
    cardFailTip: 'クレジットカードでの引き落としができませんでした。明日再度お手続きを行いますので、必要に応じて支払カードの変更をご検討ください。',
    toSwitch: '変更へ進む',
    details: 'ご注文詳細',
    type: '種別',
    planType: '選択中のプラン',
    sumTip: '総金額=プラン単価×追加ID数×残り日数/{n}日',
    unusedTip: '未使用金額（元のプラン）＝旧プラン単価×元のID数×未使用日数/{n}日',
    priceTip: '時間に応じた単価換算、単価＝プランの元単価×残り利用日数/{n}日',
    oldPlan: '元のプラン',
    unusedTime: '未使用日数',
    actionDetail: '詳細',
    checkDetail: '詳細を確認',
    actionPay: 'お支払いへ進む',
    actionCancel: 'お申込みをキャンセル',
    cancelConfirm: 'お申込みをキャンセルしてもよろしいですか？',
    actionInvoice: '請求書 ・ 納品書 ・ 領収書をダウンロード',
    actionDiagram: '図面をダウンロード',
    submitOrder: 'この内容で申し込む',
    payOrder: 'お支払い方法を選択',
    completeOrder: 'ご契約完了',
    applican: '申請者',
    appliTime: '申請日時',
    checkCancel: 'キャンセル理由を確認',
    cancelTime: 'キャンセル時間',
    cancelReason: 'キャンセル理由',
    useTip: 'お支払い完了と同時に利用開始',
    itemList: '注文一覧',
    system: 'システム',
    selectNumber: '数量の選択',
    numberOfPlan: 'プラン数',
    numberOfID: '追加ID数',
    numberTip1: 'ID数合計：{detail0}',
    numberTip2: '選択されたプランのID数：{detail0}',
    card: {
      '3DsTip': 'クレジットカードの自動引き落としには、3Dセキュア認証が必要です。システムより認証メールを送信いたしましたので、メールをご確認の上、認証を完了してください。'
    },
    complete: 'お申し込みを完了する'
  },
  cad: {
    statusProcessing: 'CAD作図中',
    statusComplete: 'CAD作図完了',
    submit: '申請を提出する',
    completeTime: '約2〜4日',
    create: 'CAD図面作成',
    delivery: '図面の交付',
    model: 'モデル',
    innerWall: '内壁の厚さ',
    outerWall: '外壁の厚さ',
    deliveryFormat: '図面の納品形式',
    usage: '建物種別',
    type: '図面の種類',
    attachment: '既存図面データ',
    application: 'CAD図面作成依頼',
    usageResidential: '住宅',
    usageOffice: 'オフィス',
    usageShop: '店舗・施設',
    usageOthers: 'その他',
    fileCad: 'CADファイル',
    filePdf: 'PDFファイル',
    diagramFloorplan: '平面図',
    diagramCeiling: '天井伏図',
    diagramElevation: '立面図',
    tipProcessing: '現在、図面を作成しております。しばらくお待ちください。'
  },
  pay: {
    payment: 'お支払い方法',
    detailCard: 'お支払い情報 - クレジットカード',
    detailInvoice: 'お支払い情報 - 請求書',
    orderPay: 'お支払い方法を選択',
    unlimited: '無制限',
    selectMethod: 'お支払い方法',
    creditcard: 'クレジットカード',
    invoice: '請求書',
    invoiceSendTip: '請求書が{mail}に送信されますので、下記の口座にお振込みください。',
    invoiceResendTip: '請求書が{mail}に送信されました。下記の口座にお振込みください。',
    bank: '金融機関',
    banCode: '金融機関コード',
    bankName: '支店名',
    bankNumber: '支店番号',
    accountType: '口座種別',
    accountOwner: '口座名義',
    accountNumber: '口座番号',
    sendInvoice: '請求書を送信',
    noInvoice: '請求書が届かない場合はこちら',
    resendInvoice: '請求書を再送信します',
    InvoiceSent: '請求書の送信が完了しました',
    toPay: 'お支払いへ進む',
    payLoading: 'お支払い処理中です。しばらくお待ちください。',
    payJump: 'お支払い処理中です。まもなく注文画面に移動します。',
    agreement: '利用規約に同意する',
    alert: 'このご注文は銀行振込でのお支払いが必要です。受信トレイをご確認ください。もし振込に関するメールが届いていない場合や、他にご不明な点がございましたら、サービス提供側にお問い合わせください。'
  },
  team: {
    member: 'メンバー管理',
    status: '利用状況',
    statusActive: '利用中',
    statusUnactive: '有効化待ち',
    addMember: 'メンバー登録',
    deleteMember: 'メンバー削除',
    deleteMultiMember: 'メンバー一括削除',
    deleteMultiMemberTip: 'メンバーを削除すると、選択されたメンバーは貴社へのアクセスができなくなりますが、クラウドにアップロードされたモデルは保持されます。削除してもよろしいでしょうか？',
    editMember: 'メンバー編集',
    deleteMemberTip: 'メンバーを削除すると、そのメンバーは貴社へのアクセスができなくなりますが、クラウドにアップロードされたモデルは保持されます。削除してもよろしいでしょうか？',
    addMultiMember: 'メンバー一括登録',
    memberFormDownload: '「メンバー一括登録テンプレート」をダウンロード',
    addMultiMemberTip: '1.「メンバー一括登録テンプレート」をダウンロードします；\\n\n2.ファイルを開き、情報をテキストや数字で入力するか、貼り付けてください；\\n\n3. 「アップロード」ボタンをクリックし、先ほど作成したメンバー情報のファイルを選択してアップロード後、右下の「インポート確認」ボタンをクリックしてください。\\n\n※一度にインポートできるデータは100件までです。データが100件を超える場合、すべてのデータがインポートされません。',
    errorNoFile: 'ファイルをアップロードしてください',
    usedSeat: '利用中ID',
    model: '全モデル数',
    cloudModel: 'クラウド上のモデル数',
    name: '氏名',
    inputLastname: '姓を入力',
    inputname: '名を入力',
    mail: 'メールアドレス',
    mailAddress: 'メールアドレス',
    inputEmail: 'メールアドレスを入力',
    emptyEmail: 'メールアドレスを入力してください',
    errorEmail: '入力されたメールアドレスの形式が正しくありません。ご確認の上、もう一度お試しください。',
    activeAccount: 'アカウントを有効化',
    activeAccountTip: 'このメンバーにはアクティベーションメールが届きます。アカウントを有効化しますか？',
    lastLogin: '最後のログイン日時',
    contactPhone: 'お客様サポート：',
    contactEmail: 'お問い合わせメール：',
    statusDisabled: '停止中',
    role: {
      owner: '所有者',
      superManger: 'スーパー管理者',
      manager: '管理者',
      ScanatUser: 'Scanatユーザー',
      viewUser: '閲覧ユーザー',
      name: '権限設定',
      updateSuccess: '権限設定が変更されました',
      noRole: '権限設定なし'
    },
    operate: {
      enable: '有効化',
      disable: '無効化'
    },
    prompt: {
      buyScanatWeb: 'Scanat Webサービスご購入済み'
    },
    add: {
      chooseRole: '権限設定選択',
      manageSeat: 'Scanatサービス利用',
      seatTip1: 'OFFにすると、メンバー登録してもID数は消費されません。',
      seatTip2: 'ONにすると、ID数を一つ消費します。'
    },
    enable: {
      noRight: 'このアカウントを有効化する権限がありません',
      tip: '有効化すると、このアカウントは通常通りご利用いただけます。有効化してもよろしいですか？',
      success: 'アカウントが有効化されました',
      noPlan: '貴社がサブスクリプションの対象外となるため、アカウントを有効化できません。'
    },
    disable: {
      noRight: 'このアカウントを無効化する権限がありません',
      tip: '無効化すると、このアカウントはご利用いただけなくなります。アカウントデータは削除されず、後で再度有効化できます。無効化してもよろしいですか？',
      success: 'アカウントが無効化されました'
    },
    statusDisabledTxt: '無効化済み',
    seatTip: 'ONにすると、Scanatサービスの利用が可能',
    delete: {
      noRight: 'このアカウントを削除する権限がありません'
    },
    seat: {
      total: '契約中ID',
      manageSeat: 'Scanatサービス利用',
      onSuccess: 'Scanat サービス利用設定がオンになりました',
      noSeat: '利用可能なID数が残っていないため、Scanat サービス利用設定をオンにできません',
      offSuccess: 'Scanat サービス利用設定がオフになりました'
    }
  },
  survey: {
    title: 'Scanat 解約申請フォーム',
    desc: '平素よりScanatをご利用いただきまして、誠にありがとうございます。\n解約をご希望のお客様は、下記のフォームに必要事項をご入力のうえ、ご送信くださいますようお願い申し上げます。\nフォームの受領後、弊社営業日に担当者よりお電話またはメールにて折り返しご連絡させていただきます。',
    questionReason: '解約理由（複数選択可）',
    reason1: '計測精度が低い',
    reason2: '撮影・操作方法が難しい',
    reason3: '使用頻度が少ない',
    reason4: '機能が不足している',
    reason5: '費用が高い',
    reason6: 'サポート体制が不十分',
    questionApp: '2.これまでに利用したスキャンシステムがあれば教えてください。（複数選択可）',
    app1: '3D Scanner',
    app2: 'Canvas',
    app3: 'Metascan',
    app4: 'Modelar',
    app5: 'Matterport',
    app6: 'OpalUI',
    app7: 'Polycam',
    app9: 'Scaniverse',
    app10: 'Sitescope',
    questionRecommend: '3.3Dスキャンが必要な友人に、Scanatをどれほどおすすめしたいですか？',
    descRecommend: '* 0〜10は、あなたが友人にScanatを推薦する意欲の程度を示します。0は「全く推薦したくない」、10は「非常に推薦したい」です。',
    questionOther: 'ご意見・ご要望',
    descOther: 'Scanatに対して、ご要望や追加してほしい機能・改善してほしい点などがございましたら、ぜひご記入ください。（自由記述欄）',
    submit: '送信',
    error: 'こちらの質問をご記入してください',
    complete: '送信しました',
    thanks: '貴重なお時間を頂きありがとうございます。natにてお申し込みを速やかにご対応させていただきます。',
    profileTitle: 'ご入力内容（全項目必須）',
    profileOwnerHint: '例：山田太郎',
    profilePhoneHint: '例：05017807133',
    profileMailHint: '例：scanat{\'@\'}natincs.com',
    questionReasonDesc: '該当する項目をすべてご選択ください。',
    reason7: '部署や担当者の変更による',
    reason8: '他社製品への乗り換え',
    contactTip: '内容にご不明点がある場合は、下記までお気軽にお問い合わせください。',
    contact: '【お問い合わせ窓口】\n- 電話番号：050-1780-7133\n- メールアドレス：cs{\'@\'}natincs.com',
    profileOwnerEmpty: '主担当者を入力してください',
    profilePhoneEmpty: '電話番号を入力してください',
    profileMailEmpty: 'メールアドレスを入力してください',
    profilePhoneError: '有効な電話番号を入力してください',
    profileMailError: '有効なメールアドレスを入力してください',
    reasonOtherEmpty: '必須項目です。内容を入力してください',
    reasonEmpty: '解約理由を選択してください',
    waiting: '処理中です。お待ちください。',
    submited: '解約申請フォームが送信されました。しばらくお待ちください。\n- 電話番号：050-1780-7133\n- メールアドレス：cs{\'@\'}natincs.com ',
    submitedOther: '{id}は解約申請フォームを送信しました。しばらくお待ちください。\n- 電話番号：050-1780-7133\n- メールアドレス：cs{\'@\'}natincs.com'
  },
  log: {
    title: '操作ログ',
    searchHint: 'アカウントを入力して検索',
    remark: '※過去1年間の操作ログを確認可能',
    account: 'アカウント',
    time: '操作時間',
    system: '所属システム',
    page: '操作画面',
    action: 'アクション',
    detail: '詳細',
    ip: 'IPアドレス',
    device: 'デバイス',
    overtimeError: '1年以上前のログは確認できません、別の期間を選択してください。',
    noUserError: 'アカウントが見つかりません。'
  },
  logs: {
    operateSystem: {
      value3: 'Scanat App',
      value4: 'Scanat Web',
      value1: 'ID管理'
    },
    operatePage: {
      login: 'ログイン／新規登録',
      personal_setting: '個人設定',
      local_model: 'ローカルモデル',
      in_box: '受信箱',
      cloud_model: 'クラウドモデル',
      sample_model: 'サンプルリスト',
      main_list: 'メインリスト',
      member_manage: 'ID管理',
      company_info: '会社情報',
      order_manage: '注文履歴',
      SharedSpace: '共有空間',
      TeamsSpace: 'チーム空間',
      team_space: 'チームスペース',
      personal_space: '個人スペース',
      model_link: 'モデルリンク',
      invite_link: '招待リンク'
    },
    operateType: {
      login: 'ログイン',
      register: '新規登録',
      cancellation: 'アカウントを削除',
      deleteModel: 'モデルを削除',
      addModel: 'モデルを新規作成',
      viewModel: 'モデルを閲覧',
      viewSampleModel: 'モデルを閲覧',
      editModel: 'モデルを変更',
      editModelInfo: 'モデルを変更',
      editModelAvatar: 'モデルを変更',
      editModelName: 'モデルを変更',
      shareModel: 'モデルを転送',
      copyModelShareLink: 'モデルを転送',
      moveModel: 'モデルを移動',
      uploadModel: 'モデルをアップロード',
      exportModel: 'モデルをエクスポート',
      copyModel: 'モデルを複製',
      applyCad: 'CAD図面作成依頼',
      addFolder: 'フォルダ新規作成',
      editFolder: 'フォルダを変更',
      deleteFolder: 'フォルダを削除',
      moveFolder: 'フォルダを移動',
      downloadModel: 'モデルをダウンロード',
      buyAccountPlan: 'プランを購入',
      inviteMember: 'メンバーを登録',
      addEnableMember: 'メンバーを登録',
      addMember: 'メンバーを登録',
      addDisableMember: 'メンバーを登録',
      enableMember: 'メンバーを登録',
      disableMember: 'メンバーを変更',
      setMemberAdmin: 'メンバーを変更',
      unsetMemberAdmin: 'メンバーを変更',
      editMemberName: 'メンバーを変更',
      editCustomerInfo: '情報を変更',
      editCustomer: '情報を変更',
      downloadInvoices: '請求書 ・ 納品書 ・ 領収書をダウンロード',
      expandOrder: 'ID数追加',
      changeCard: '支払いクレジットカードの変更',
      batchAddMembers: '一括登録',
      batchDeleteMembers: '一括削除',
      activeMember: 'メンバーIDを有効化',
      deleteMember: 'メンバーIDを削除',
      payOrder: '注文の支払い',
      cancelOrder: '注文のキャンセル',
      exportMember: 'エクスポート',
      buyOrder: 'プランを購入',
      URLreset: 'URLをリセット',
      FolderSharing: 'フォルダを共有',
      planCancelApplication: 'プラン解約申請',
      editLink: 'リンク変更',
      PermissionChange: '権限を変更',
      moveModelHome: 'モデルを移動',
      moveFolderHome: 'フォルダを移動',
      copyLink: 'モデルを転送',
      changeLink: 'リンクを変更',
      changeLinkPassword: 'リンクを変更',
      resetPassword: 'パスワードをリセット',
      addMemberNew: 'メンバーを登録',
      editMemberStatus: 'メンバーを変更',
      editMemberNew: 'メンバーを変更',
      enable: 'メンバーを有効化',
      disable: 'メンバーを無効化',
      changeSeat: 'Scanatサービス利用を変更',
      changeRole: '権限設定を変更',
      uploadFile: 'モデルファイルをインポート',
      manageCollaborator: '協働メンバーを管理',
      moveFolderToFolder: 'フォルダを移動',
      moveFolderToRoot: 'フォルダを移動',
      moveModelToFolder: 'モデルを移動',
      moveModelToRoot: 'モデルを移動',
      addCollaborator: '協働メンバーを管理',
      deleteCollaborator: '協働メンバーを管理',
      updateCollaborator: '協働メンバーを管理',
      inviteCollaborator: '協働メンバーを追加',
      resentInvite: '協働メンバーを追加',
      resentInviteWithDate: '協働メンバーを追加',
      acceptInvite: '招待を承諾',
      viewFolder: 'フォルダを開く',
      uploadToFolder: 'モデルをアップロード',
      uploadToRoot: 'モデルをアップロード',
      importFileToRoot: 'モデルファイルをインポート',
      importFileToFolder: 'モデルファイルをインポート'
    },
    detail: {
      register: '新規アカウントを作成しました。',
      login: 'システムにログインしました。',
      cancellation: 'アカウントを削除しました。',
      deleteModel: 'モデル「{detail0}」を削除しました。',
      addModel: 'モデル「{detail0}」を「{detail1}」でスキャンしました。',
      viewModel: 'モデル「{detail0}」を確認しました。',
      editModelInfo: 'モデル「{detail0}」の情報を「モデル名：{detail1}；郵便番号：{detail2}；住所：{detail3}；建物名：{detail4}」に変更しました。',
      editModelAvatar: 'モデル「{detail0}」のカバー画像を変更しました。',
      editModel: 'モデル「{detail0}」に「{detail1}」操作を行いました。',
      moveModel: 'モデル「{detail0}」をフォルダ「{detail1}」に移動しました。',
      uploadModel: 'モデル「{detail0}」をクラウドにアップロードしました。',
      exportModel: 'モデル「{detail0}」のデータをエクスポートしました。',
      copyModel: 'モデル「{detail0}」を「{detail1}」として複製しました。',
      applyCad: 'モデル「{detail0}」のCAD図面作成を依頼しました。',
      addFolder: 'フォルダ「{detail0}」を新規作成しました。',
      editFolder: 'フォルダ「{detail0}」の名称を「{detail1}」に変更しました。',
      deleteFolder: 'フォルダ「{detail0}」を削除しました。',
      moveFolder: 'フォルダ「{detail0}」をフォルダ「{detail1}」に移動しました。',
      downloadModel: 'モデル「{detail0}」をダウンロードしました。',
      viewSampleModel: 'モデル「サンプルモデル」を確認しました。',
      editModelName: 'モデル「{detail0}」の名称を「{detail1}」に変更しました。',
      buyAccountPlan: '「{detail0}」を購入しました。ID上限は{detail1}で、金額は税込{detail2}円、支払い方法は「{detail3}」です。',
      addEnableMember: 'メンバー「{detail0}」を追加しました。状態は「有効」です。',
      addDisableMember: 'メンバー「{detail0}」を追加しました。状態は「使用不可」です。',
      inviteMember: 'メンバー「{detail0}」を追加しました。今は相手の承諾待ち状態です。',
      enableMember: 'メンバー「{detail0}」の状態を「有効」に設定しました。',
      disableMember: 'メンバー「{detail0}」の状態を「使用不可」に設定しました。',
      setMemberAdmin: 'メンバー「{detail0}」を管理者に設定しました。',
      unsetMemberAdmin: 'メンバー「{detail0}」の管理者権限を解除しました。',
      editMemberName: 'メンバー「{detail0}」の名前を「{detail1}」に変更しました。',
      editCustomerInfo: '会社情報を「郵便番号：{detail0}、都道府県：{detail1}、市村町：{detail2}、住所：{detail3}、責任者姓：{detail4}、責任者名：{detail5}、電話番号：{detail6}、業種：{detail7}、従業員数：{detail8}、主要業務：{detail9}」に変更しました。',
      downloadInvoices: '注文「{detail0}」の請求書をローカルにダウンロードしました。',
      moveModelHome: 'モデル「{detail0}」を「ホーム」に移動しました。',
      moveFolderHome: 'フォルダ「{detail0}」を「ホーム」に移動しました。',
      expandOrder: '「ID数追加」注文を提出しました。注文情報：「注文番号：{detail0}；プラン：{detail1}；注文タイプ：ID追加；サブスクリプション形式：{detail2}；追加ID数：{detail3}；開始日：{detail4}；金額：{detail5}；税金：{detail6}；支払金額：{detail7}」',
      buyOrder: '「プラン購入」注文を提出しました。注文情報：「注文番号：{detail0}；プラン：{detail1}；注文タイプ：購入；サブスクリプション形式：{detail2}；ID数：{detail3};  金額：{detail4}；税金：{detail5}；支払金額：{detail6}」',
      changeCard: '支払いクレジットカードを{detail0}に変更しました。',
      addMember: 'メンバー「{detail0}」を追加しました。状態は「{detail1}」です。',
      batchAddMembers: '{detail0}人のメンバーを一括で追加しました。',
      batchDeleteMembers: '{detail0}人のメンバーを一括で削除しました。',
      exportMember: 'メンバーリストをエクスポートしました。',
      activeMember: 'メンバー「{detail0}」を有効化しました。',
      deleteMember: 'メンバー「{detail0}」を削除しました。',
      editCustomer: '会社情報を「会社名：{detail0}、担当者：{detail1}、{detail2}、{detail3}；郵便番号：{detail4}；住所：{detail5}；業種：{detail6}；従業員数：{detail7}；資本金：{detail8}；主要業務：{detail9}」に変更しました。',
      payOrder: '注文「{detail0}」の支払いが完了しました。支払い方法は「{detail1}」です。',
      cancelOrder: '注文「{detail0}」をキャンセルしました。',
      SendModelViewable: 'モデル「{detail0}」をユーザー「{detail1}」に転送しました。アクセス権限は「閲覧可能」です。',
      CopiedModelPrivateLink: 'モデル「{detail0}」の「プライベートリンク」をコピーしました。',
      AddedModelMember: 'モデル「{detail0}」にメンバー「{detail1}」を「閲覧可能」権限で追加しました。',
      UpdatedModelMember: 'モデル「{detail0}」のメンバー「{detail1}」の権限を「編集可能」に変更しました。',
      RemovedModelViewable: 'モデル「{detail0}」からメンバー「{detail1}」の「閲覧可能」権限を削除しました。',
      ResetModelPrivateLink: 'モデル「{detail0}」の「プライベートリンク」をリセットしました。',
      SharedFolder: 'フォルダ「{detail0}」をユーザー「{detail1}」に共有しました。',
      CopiedFolderPublicLink: 'フォルダー「{detail0}」の「公開リンク」をコピーしました。',
      ResetModelPublicLink: 'モデル「{detail0}」の「公開リンク」をリセットしました。',
      SendModelEditable: 'モデル「{detail0}」をユーザー「{detail1}」に転送しました。アクセス権限は「編集可能」です。',
      RenamedFolder: 'フォルダー「{detail0}」を「フォルダー名：{detail1}；概要：{detail2}」に変更しました。',
      SharedFolderViewable: 'フォルダー「{detail0}」をユーザー「{detail1}」に共有しました。アクセス権限は「閲覧可能」です。',
      CopiedFolderPrivateLink: 'フォルダー「{detail0}」の「プライベートリンク」をコピーしました。',
      AddedFolderMember: 'フォルダー「{detail0}」にメンバー「{detail1}」を「閲覧可能」権限で追加しました。',
      UpdatedFolderMember: 'フォルダー「{detail0}」のメンバー「{detail1}」の権限を「編集可能」に変更しました。',
      RemovedFolderViewable: 'フォルダー「{detail0}」からメンバー「{detail1}」の「閲覧可能」権限を削除しました。',
      ResetFolderPublicLink: 'フォルダー「{detail0}」の「公開リンク」をリセットしました。',
      addModel1: '間取りスキャン',
      addModel2: 'ノーマルりスキャン',
      editModel1: '切り取り',
      editModel2: '位置を合わせる',
      editModel3: '変形',
      buyAccountPlan2: '請求書',
      buyAccountPlan1: 'クレジットカード',
      editCustomerSex0: '男',
      editCustomerSex1: '女',
      editCustomerInfo1: '建設業',
      editCustomerInfo2: '製造業',
      editCustomerInfo3: '不動産業・物品賃貸業',
      editCustomerInfo4: '情報通信業',
      editCustomerInfo5: '電気・ガス・熱供給・水道業',
      editCustomerInfo6: '運輸業・郵便業',
      editCustomerInfo7: '情報処理サービス業',
      editCustomerInfo8: '学術研究・専門・技術サービス業',
      editCustomerInfo9: '卸売業・小売業',
      editCustomerInfo10: 'リサーチ業',
      editCustomerInfo0: '-',
      editCustomerInfoStaff1: '1~50',
      editCustomerInfoStaff2: '51~100',
      editCustomerInfoStaff3: '100名以上',
      editCustomerInfoStaff0: '-',
      editCustomer1: '建設業',
      editCustomer2: '製造業',
      editCustomer3: '不動産業・物品賃貸業',
      editCustomer4: '情報通信業',
      editCustomer5: '電気・ガス・熱供給・水道業',
      editCustomer6: '運輸業・郵便業',
      editCustomer7: '情報処理サービス業',
      editCustomer8: '学術研究・専門・技術サービス業',
      editCustomer9: '卸売業・小売業',
      editCustomer10: 'リサーチ業',
      editCustomer0: '-',
      editCustomerStaff1: '1~50',
      editCustomerStaff2: '51~100',
      editCustomerStaff3: '100名以上',
      editCustomerStaff0: '-',
      payOrder1: 'クレジットカード',
      payOrder2: '請求書',
      addMember0: '有効化待ち',
      addMember1: '利用中',
      period1: '年払い',
      period2: '月払い',
      planCancelApplication: 'プラン解約申請を提出しました。',
      shareModel: 'モデル「{detail0}」をユーザー「{detail1}」に転送しました。',
      copyModelShareLink: 'モデル「{detail0}」の共有リンクをコピーしました。',
      changeLinkPassword: 'モデル「{detail0}」のパスワード付きリンクのパスワードを変更しました。',
      ResetModelLink: 'モデル「{detail0}」の「{detail1}」をリセットしました。',
      ResetFolderLink: 'フォルダ「{detail0}」の「{detail1}」をリセットしました。',
      resetPassword: 'パスワードをリセットしました。',
      copyLink1: 'プライベートリンク',
      copyLink2: 'パスワード付きリンク',
      copyLink3: '公開リンク',
      changeLink1: 'プライベートリンク',
      changeLink2: 'パスワード付きリンク',
      changeLink3: '公開リンク',
      copyLink: 'モデル「{detail0}」の「{detail1}」をコピーしました。',
      changeLink: 'モデル「{detail0}」の共有リンク権限を「{detail1}」に変更しました。',
      editMemberStatus: 'メンバー「{detail0}」の状態を「{detail1}」に変更しました。',
      addMemberNew: 'メンバー「{detail0}」を追加しました。権限設定：「{detail1}」；Scanat サービス利用設定：「{detail2}」；ステータス：「利用中」',
      editMemberNew: 'メンバー「{detail0}」の名前を「{detail1}」に、権限設定を「{detail2}」に、Scanat サービス利用設定を「{detail3}」に変更しました。',
      enable: 'メンバー「{detail0}」を有効化しました。',
      disable: 'メンバー「{detail0}」を無効化しました。',
      changeSeat: 'メンバー「{detail0}」のScanat サービス利用設定を「{detail1}」に変更しました。',
      changeRole: 'メンバー「{detail0}」の権限設定を「{detail1}」に変更しました。',
      role1: 'スーパー管理者',
      role3: '管理者',
      role0: 'Scanatユーザー',
      role4: '閲覧ユーザー',
      changeSeat1: 'オン',
      changeSeat0: 'オフ',
      uploadFile: 'モデル「{detail0}」をインポートしました。ファイル形式は{detail1}です。',
      uploadToFolder: 'モデル「{detail0}」を{detail1}のフォルダ「{detail2}」にアップロードしました。',
      uploadToRoot: 'モデル「{detail0}」を{detail1}の「ホーム」にアップロードしました。',
      moveFolderToFolder: 'フォルダ「{detail0}」を{detail1}のフォルダ「{detail2}」に移動しました。',
      moveFolderToRoot: 'フォルダ「{detail0}」を{detail1}の「ホーム」に移動しました。',
      moveModelToFolder: 'モデル「{detail0}」を{detail1}のフォルダ「{detail2}」に移動しました。',
      moveModelToRoot: 'モデル「{detail0}」を{detail1}の「ホーム」に移動しました。',
      addCollaborator: '「{detail2}」を{detail0}「{detail1}」の協働メンバー、権限を「{detail3}」に設定しました。',
      deleteCollaborator: '協働メンバー「{detail2}」を{detail0}「{detail1}」から削除しました。',
      updateCollaborator: '{detail0}「{detail1}」の協働メンバー「{detail2}」の権限を「{detail3}」に設定しました。',
      space0: '個人スペース',
      space1: 'チームスペース',
      fileType0: 'モデル',
      fileType1: 'フォルダ',
      collaboratorPermission0: '閲覧のみ',
      collaboratorPermission1: '編集可能',
      collaboratorPermission2: '管理可能',
      importFile: 'モデル「{detail0}」をインポートしました。ファイル形式は{detail1}です。',
      inviteCollaborator: '「{detail0}」に協働メンバーの招待を送信しました。権限は{detail1}、有効期限は{detail2}日です。',
      resentInvite: '「{detail0}」に協働メンバーの招待を再送信しました。',
      resentInviteWithDate: '「{detail0}」に協働メンバーの招待を再送信しました。有効期限は{detail1}日です。',
      acceptInvite: '協働メンバーの招待を承諾しました。',
      viewFolder: 'フォルダ「{detail0}」を開きました。',
      importFileToRoot: 'モデル「{detail0}」を{detail1}のルートディレクトリにインポートします。ファイル形式は{detail2}です。',
      importFileToFolder: 'モデル「{detail0}」を{detail1}のフォルダ「{detail2}」にインポートします。ファイル形式は{detail3}です。'
    }
  },
  period: {
    lastWeek: '過去1週間',
    lastMonth: '過去1か月',
    lastYear: '過去1年'
  },
  menu: {
    company: '会社情報',
    log: '操作ログ',
    order: '注文履歴',
    team: 'ID管理'
  },
  title: {
    team: 'ID管理',
    company: '会社情報',
    order: '注文履歴',
    log: '操作ログ',
    buy: '商品購入',
    pay: '注文のお支払い',
    paySuccess: 'お支払い完了',
    orderInfo: 'ご注文の詳細',
    land: '利用サービス選択',
    link: {
      useless: 'リンクが無効です',
      notExist: 'リンクが見つかりません'
    }
  },
  SUCCESS: '操作完了',
  VALIDATE_FAILED: 'パラメータ検証に失敗しました。',
  UNAUTHORIZED: 'まだ登録されていないか、ログインセッションの有効期限が切れました。',
  INVALID_PASSWORD: 'ユーザー名とパスワードを確認してください。',
  UNAVAILABLE: '登録されたアカウントには法人契約後に営業担当者によるアクティベーションが必要です。ご検討いただける方はにご連絡ください。',
  FORBIDDEN: '必要な権限が付与されていません。',
  POSTCODE_NOT_EXIST: '郵便番号が存在しません。',
  NOT_REGISTERED: 'このメールアドレスは登録されていません。',
  VERIFICATION_CODE_ERROR: '認証コードが正しくありません。',
  VERIFICATION_CODE_EXPIRE: '認証コードの有効期限が切れています。',
  USER_NOT_EXIST: 'このユーザーは存在しません。',
  CRM_ACCOUNT_NOT_EXIST: 'アカウントが存在しません。カスタマーサービスに連絡してください。',
  USER_EXIST: 'このユーザーはすでに存在しています。',
  CONFIRM_PASSWORD: '入力されたパスワードが一致しません。',
  FILE_UPLOAD_KEY_GET_FAIL: 'キーを取得できません。',
  MODEL_NOT_BELONG: 'このモデルは他のユーザーが所有しています。',
  FAILED: '操作失敗',
  REQUEST_FREQUENTLY: '操作が頻繁すぎます。しばらく時間をおいてから再度お試しください。',
  FILE_SHARE_ERROR_DEL: '転送に失敗しました。ファイルがすでに削除されました。',
  FILE_SHARE_ERROR_UNAUTHORIZED: '権限がありません。',
  FILE_SHARE_ERROR_EMAIL_NOT_EXISTS: 'ユーザーIDが存在しません。',
  FILE_SHARE_ERROR_UNKNOWN: '未知のエラー',
  FILE_SHARE_ERROR_REPEAT_SHARING: 'モデルはすでにこのユーザーに転送されています。',
  FILE_SHARE_ERROR_SELF: '自分に転送できません。',
  FILE_SHARE_UPDATE_FAIL: '更新失敗。転送されたファイルが見つかりません。',
  FILE_DOWNLOAD_ERROR_DEL: 'ファイルがすでに削除されましたため、ダウンロードできません。',
  FILE_SHARE_DEL_FAIL: '転送されたモデルがないため、削除できません。',
  FILE_SHARE_DEL_FAIL_NO_AUTHORITY: '転送されたモデルは削除できません。',
  CREDIT_CARD_PAY_ERROR: '購読の復元に失敗しました。',
  CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY: 'カード支払いに失敗しました。原因：データが存在しません。',
  PERMITS_CONVERT_FAIL: '購読の復元に失敗しました。',
  PERMITS_CONVERT_FAIL_USER_NULL: '購読の復元に失敗しました。',
  APP_TRANSLATION_INVALID: 'ユーザーが存在しません',
  APP_TRANSLATION_HISTORY_GET_FAIL: '購読データの取得に失敗しました。',
  APP_TRANSLATION_STATUS_GET_FAIL: '購読データの取得に失敗しました。',
  FILE_UPLOAD_FILE_PATH_EMP_ERROR: '更新に失敗しました：ファイルパスを入力してください',
  FILE_UPLOAD_FILE_DB_FAIL_ERROR: '更新に失敗しました：モデル記録にエラーが発生しました。',
  APP_TOKEN_GET_FAIL: 'パラメーターの取得に失敗しました。',
  APP_IP_ADDRESS_NOT_ALLOW: 'IPアドレスにアクセスできません。',
  CONTACT_ALREADY_EXIST: '連絡先が既に存在しています。',
  ACCOUNT_PLAN_NOT_EXIST: 'プランを購入していません。',
  ACCOUNT_PLAN_TYPE_ERROR: 'プランのタイプを確認してください。',
  ACCOUNT_PLAN_DOWNGRADE: '現在のプランより低いプランへの変更はできません。',
  ACCOUNT_PLAN_PREPAY_MONTH_ERROR: 'プランの情報を確認してください。',
  ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER: '前払い期間が終了するまで、プランを変更できません。',
  CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST: 'ユーザーのFincode IDが見つかりません。',
  FINCODE_PLAN_ID_NOT_EXIST: 'Fincode IDが存在しません。',
  CUSTOMER_NAME_DUPLICATE: 'ユーザー名はすでに存在しています。再度確認してください。',
  CUSTOMER_NAME_BLANK_NOT_ALLOW: 'ユーザー名を入力してください。',
  ACCOUNT_NOT_EXIST: 'ユーザーIDが存在しません。',
  CUSTOMER_NOT_EXIST: 'ユーザーが存在しません。',
  FINCODE_CARD_ID_BLANK_NOT_ALLOW: 'Fincode IDを入力してください。',
  CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN: 'ユーザーはプランと関連付けられていません。',
  CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT: 'お支払いリクエストは送信済みで、決済結果を確認中です。しばらくお待ちください。',
  ACCOUNT_IN_USE_HAS_REACHED_MAX: '利用可能のID数は上限になリました。',
  ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX: '追加されたID数と現在利用中のID数の合計が、プランのID数上限を超えています。',
  ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES: 'このメールアドレスはすでに登録されています。',
  ACCOUNT_EMAIL_ALREADY_EXISTS: 'メールアドレスは既に存在しています。',
  ACCOUNT_LIST_CANNOT_BE_EMPTY: 'アカウントリストを入力してください。',
  FREEE_TOKEN_GET_ERROR: 'Freeeの認証エラーが発生しました',
  FREEE_API_REQUEST_ERROR: 'FreeeのAPIにリクエストするときエラーが発生しました。',
  FREEE_INVOICE_LIST_ERROR: 'FreeeのAPIに請求書リストの取得をリクエストするときエラーが発生しました。',
  FREEE_INVOICE_DETAIL_ERROR: 'FreeeのAPIに請求書詳細の取得をリクエストするときエラーが発生しました。',
  FREEE_ADD_INVOICE_ERROR: 'FreeeのAPIに請求書の追加をリクエストするときエラーが発生しました。',
  FREEE_ADD_PARTNER_ERROR: 'FreeeのAPIに顧客の追加をリクエストするときエラーが発生しました。',
  FREEE_UPDATE_PARTNER_ERROR: 'FreeeのAPIに顧客の更新をリクエストするときエラーが発生しました。',
  FREEE_PARTNER_DETAIL_ERROR: 'FreeeのAPIに顧客情報の取得をリクエストするときエラーが発生しました。',
  FREEE_PARTNER_LIST_ERROR: 'FreeeのAPIに顧客リストの取得をリクエストするときエラーが発生しました。',
  ACCOUNT_PLAN_ORDER_NOT_EXISTS: '顧客の契約プラン情報が存在しません。',
  CUSTOMER_ALREADY_ADDED: '顧客情報はすでに存在しています。',
  ORDER_NOT_EXIST: '注文が存在しません。',
  ORDER_STATUS_ERROR: '注文ステータスエラー',
  ORDER_PAYMENT_METHOD_NOT_ALLOW: '支払い方法がサポートされていません。',
  FINCODE_CUSTOMER_CARD_NOT_FOUND: 'Fincodeカードが存在しません。',
  FREEE_PARTNER_NOT_FOUND: 'Freee顧客情報が見つかりません。',
  CUSTOMER_ALREADY_BOUND_PLAN: '支払依頼がすでに送信されました。重複して送信しないください。',
  MY_USER_PHONE_NUMBER_ALREADY_EXISTS: '電話番号はすでに存在しています。',
  MY_USER_EMAIL_ALREADY_EXISTS: 'メールアドレスはすでに存在しています。',
  ROLE_NAME_DUPLICATE: 'ロール名はすでに存在しています。',
  THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED: 'このロールは現在ユーザーに割り当てられているため、無効化できません。',
  THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT: 'このロールは現在ユーザーに割り当てられているため、編集できません。',
  THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED: 'このロールは現在ユーザーに割り当てられているため、削除できません。',
  ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS: '本部に下位部門を追加できません。',
  AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION: '代理店の郵便番号と住所情報を入力してください。',
  MOST_FIVE_DEPT_LEVELS: '部門の階層は最大5階層までと制限されています。これ以上階層を追加できません。',
  DEPT_NAME_ALREADY_EXISTS: '部門名はすでに存在しています。',
  THE_DEPT_HAS_SUB_DEPT: 'この部門には下位部門が存在するため、削除できません。',
  THERE_ARE_USERS_IN_THIS_DEPT: 'この部門にはユーザーが関連付けられているため、削除できません。',
  THERE_ARE_ROLES_BOUND_TO_THIS_DEPT: 'この部門にはロールが関連付けられているため、削除できません。',
  THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT: 'この部門はアカウントプランを保有しているため、削除できません。',
  CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD: '顧客名はすでに存在しているため、新規追加できません。',
  THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS: '顧客が関連付けられた部門が存在しません。',
  CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE: '顧客名はすでに存在しているため変更できません。',
  THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT: 'この顧客にはプランが関連付けられていないため、アカウントを有効化できません。',
  THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT: 'この顧客のプランはまだ有効化されていないため、アカウントを有効化できません。',
  THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED: '有効なアカウント数が上限に達したため、これ以上アカウントを有効化できません。',
  THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: 'この顧客には関連つけられたプランがないため、有効なアカウントを移管できません。',
  THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: 'この顧客のプランはまだ有効化されていないため、有効なアカウントを移管できません。',
  THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: 'この顧客にはプランが関連付けられていないため、有効なアカウントを追加できません。',
  THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: 'この顧客のプランはまだ有効化されていないため、有効なアカウントを追加できません。',
  THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT: '有効なアカウント数がすでにプランIDの上限に達しているため、有効なアカウントを追加できません。',
  THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST: '代理店ユーザーにはCAD注文リストを表示する権限がありません。',
  CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES: '注文はすでに完了しました。ファイルを追加できません。',
  CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE: 'このロールは本部に所属しているため、代理店のみがアクセスできるメニューには関連付けられません。',
  CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE: 'このロールは代理店に所属しているため、本部のみがアクセスできるメニューには関連つけられません。',
  THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED: 'このプランは現在顧客に使用されているため、削除できません。',
  THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE: 'デバイスの所属部門に代理店を指定できません。',
  CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED: 'このデバイスは現在顧客が使用中のため、削除できません。',
  THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED: '現在のデバイスが有効なアカウントプランの標準見積もりデバイスとして使用されているため、削除できません。',
  ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: '顧客名はすでににデータベースに存在しているため、新規顧客として追加できません。',
  ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS: '顧客名は既に存在しているため、新規追加できません。',
  UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: '顧客名はすでににデータベースに存在しているため、更新できません。',
  THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT: '該当の顧客は解約されていない契約注文がありますので、所属部署を変更できません。',
  THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT: '該当の顧客は解約されていないデバイスの注文がありますので、所属部署を変更できません。',
  CUSTOMER_INFO_NOT_ADDED: '企業情報が入力されていません。企業情報メニューバーで企業情報を入力した後、プランの購入が可能になります。',
  FREEE_PARTNER_NOT_EXIST: 'Freeeで該当する情報が見つからない場合は、アカウントIDが正しく入力されているかご確認ください。',
  INVITATION_NOT_EXIST: '招待が存在しません。',
  INVITATION_STATUS_ERROR: '招待ステータスエラー',
  INVITATION_STATUS_INVALID: '招待が取り消されました。招待元の管理者に連絡して、招待を再送してください。',
  INVITATION_STATUS_EXPIRED: '招待が期限切れになりました。招待元の管理者に連絡して、招待を再送してください。',
  INVITATION_CHECK_CODE_WRONG: '入力された認証コードが正しくありません。',
  CUSTOMER_ACCOUNT_PLAN_IN_EFFECT: 'このアカウントはすでに登録されています。招待先のアカウントが正しいか確認してください。',
  CUSTOMER_NOT_ALLOW_CHANGE: '顧客を変更できません。',
  USER_STATUS_UNAVAILABLE: 'Scanatのご利用には有料契約が必要です。Scanatの製品サイトでプランを購入してから、ログインしてください。',
  USER_STATUS_AVAILABLE: 'ログインしました。',
  USER_STATUS_ACCOUNT_EXPIRED: 'アカウントは期限切れになりました。プランを更新してください。',
  USER_STATUS_LOGOUT: '該当のアカウントが存在しません。アカウント情報を確認して、再度お試しください。',
  USER_STATUS_ACTIVE: 'ログインしました。',
  USER_STATUS_TO_BE_EFFECTIVE: 'アカウントはまだ有効化されていません。貴社の管理者%@にお問い合わせください。',
  USER_STATUS_DEACTIVATE: 'アカウントは管理者によって無効化されています。貴社の管理者%@にお問い合わせください。',
  USER_STATUS_PRE_DEACTIVATE: 'ログインしました。',
  USER_STATUS_PRE_ABNORMALITY: 'アカウントに問題が発生しているため、現在ログインできません。',
  AGENT_NOT_EXIST: '代理店が存在しません。',
  AGENT_NAME_DUPLICATE: '代理店名がすでに存在しています。',
  REQUEST_BOOK_NOT_EXIST: '請求書が存在しません。',
  FILE_CREATE_FAIL: 'ファイル作成に失敗しました。',
  SALES_DATE_EMPTY: '取引日を入力してください。',
  EXTEND_PLAN_CONFIG_ERROR: 'ID追加プランが設定されていません。管理者にお問い合わせください。',
  CAN_NOT_FIND_WEB_MODEL_KEY: 'モデルが存在しません。',
  CAN_NOT_FIND_WEB_MODEL_FOLDER: 'フォルダが存在しません。',
  FOLDER_CANT_MOVE_INTO_SUB_FOLDER: 'フォルダ移動に失敗しました。フォルダはサブフォルダまでに移動できません。',
  FOLDER_CONTAIN_SUB_FOLDER: 'フォルダ移動に失敗しました。指定されたフォルダはサブフォルダを含めていたので移動できません。',
  WEB_MODEL_ALREADY_IN_FOLDER: '移動に失敗しました。このデータはすでにフォルダに存在します。',
  FOLDER_NAME_SAME: '同じ名前のフォルダがすでに存在しています。名前を変更してから保存してください。',
  EMAIL_CODE_REQUIRED: 'セキュリティ向上のため、認証コード機能を追加しました。この機能をご利用いただくには、アプリを最新バージョン（v1.8.2以上）にアップデートしてください。',
  FILE_SHARE_FAIL: '転送に失敗しました：{}',
  NOT_HAS_WEB_PERMISSION: '本サービスをご購入いただいていないため、アクセスできません。',
  MODEL_OUTLINE_NOT_EXIST: 'モデルの下図が存在しません。',
  WEB_MODEL_NO_AUTH: '権限が不足しています。',
  SEAT_NUM_TOO_SMALL: 'ID数が最小制限を下回っています。',
  SEAT_NUM_TOO_BIG: 'ID数が最大制限を超えています。',
  SEAT_NUM_LESS_THAN_USED: 'ID数が不足しています。',
  CUSTOMER_PLAN_NOT_CANCELED: 'お客様にはキャンセル済みのプランはございません。',
  CUSTOMER_PLAN_EXIST: 'お客様は既にプランをご購入済みです。',
  CUSTOMER_PLAN_ALREADY_CANCELED: 'お客様のプランはキャンセルされました。',
  CUSTOMER_PLAN_NOT_A: 'お客様はプランAの契約者ではありません。',
  CUSTOMER_PLAN_PERIOD_ERROR: 'このサブスクリプション形式には対応しておりません。',
  START_TIME_ILLEGAL: '開始時間が正しくありません。',
  STRIPE_ONE_TIME_PRICE_NOT_FOUND: '該当プランが存在しません。',
  CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM: '該当プランが存在しません。',
  ORDER_NOT_BELONG: 'この注文は、お客様の会社に属するものではありません。',
  WEB_PERMISSION_NOT_ALLOW_INACTIVE: '権限が不足しています。',
  CUSTOMER_HAS_ACCOUNT_IN_USE: '貴社には現在、利用中のアカウントがあります。',
  CAD_PLAN_GOODS_NOT_EXIST: 'このCAD商品が見つかりませんでした。',
  CAD_ORDER_NOT_EXIST: '該当するCAD注文は存在しません。',
  CAD_ORDER_STATUS_ERROR: '該当するCAD注文のステータスは正しくありません。',
  CAD_ORDER_FILE_TOO_MANY: '該当するCAD注文のファイルサイズが上限を超えています。',
  ACCOUNT_PLAN_PERIOD_NOT_ALLOW: 'このサブスクリプション形式には対応しておりません。',
  CUSTOMER_PLAN_END_TIME_BEFORE_NOW: 'プランの有効期限がまだ切れていません。',
  EXPAND_SEAT_NOT_ZERO: '追加ID数は1以上に設定してください。',
  EXPAND_A_NOT_ALLOW: 'プランAではID数の追加ができません。',
  ACCOUNT_PLAN_GOODS_NOT_EXIST: '該当プランが存在しません。',
  CAD_PLAN_GOODS_IS_USED: 'このCADプランはご利用中です。',
  DOMAIN_ALREADY_EXIST: 'このドメインは既に登録されています。',
  LOCATION_WITH_SNAPSHOT: 'この撮影スポットは既にハイライトと関連付けられています。',
  LOCATION_NOT_FOUNT: 'この撮影スポットは存在しません。',
  FLOOR_NOT_EXIST: 'フロアが存在しません。',
  AUTO_ALIGN_FAIL: '自動回転修正に失敗しました。',
  CAN_NOT_CHANGE_MEMBER_ROLE: 'メンバーの権限設定を変更することはできません。',
  CAN_NOT_USE_SEAT: '「Scanatサービス利用」のオン/オフを切り替える権限がありません。',
  APPLICATION_NOT_EXIST: '解約申請は存在しません。',
  PROCESSING_RESULT_NOT_EXIST: '解約申請の処理結果が存在しません。',
  PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST: '解約申請の理由が存在しません。',
  PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL: '解約申請では、「その他」の理由は必須項目です。',
  PLAN_CANCEL_APPLICATION_EMAIL_ERROR: '解約申請に入力されたメールアドレスが、現在のアカウントと一致しません。',
  PLAN_CANCEL_APPLICATION_EXIST: '解約申請は既に存在しています。',
  ACCOUNT_CAN_NOT_USE: 'お客様のアカウントはご利用いただけません。',
  ACCOUNT_NOT_BUY_PLAN: 'Scanatサービスはまだご購入されていません。{} にアクセスし、プランをご購入後、再度ログインしてください。',
  CUSTOMER_NOT_BUY_PLAN: '御社はScanatサービスをご購入されていないため、現在ログインできません。',
  ACCOUNT_NO_SEAT: 'このアカウントは「Scanatサービス利用」の設定がオフのため、アプリをご利用いただけません。',
  CAN_NOT_EDIT_MEMBER: 'メンバーの編集はできません。',
  MODEL_IS_NOT_EXIST: 'モデルが存在しません。',
  SHARE_LINK_NOT_EXIST: '共有リンクが存在しません。',
  NOT_CUSTOMER_MEMBER: 'この会社のメンバーではありません。',
  SHARE_LINK_PASSWORD_ERROR: '入力された共有リンクのパスワードが正しくありません。',
  STRIPE_PAYMENT_METHOD_NOT_ALLOW: 'Stripe決済には対応していません。',
  NOT_ADMIN_FORBIDDEN: '管理者ではありません。',
  NOT_ACTIVE_FORBIDDEN: 'アカウントが有効化されていません。',
  map: {
    gpsEnabledModelCount: 'GPS付与のモデル数：{n}',
    emptyFolderNoGpsModel: 'このフォルダにはGPS付与のモデルがありません。',
    searchNoResult: '結果は見つかりませんでした。キーワードを変更したり、誤字・脱字がないか確認したりするか、又は絞り込み機能を試してください。'
  },
  maps: {
    hover: {
      showAllModels: '全モデルを表示',
      zoomIn: '拡大',
      zoomOut: '縮小'
    }
  },
  collaborator: {
    set: '協働メンバーを管理',
    add: '協働メンバーを追加',
    search: {
      email: 'メンバーのメールアドレスを入力して検索'
    },
    online: 'オンライン',
    owner: '所有者（会社）',
    title: '協働メンバー'
  },
  fileModal: {
    cannotOperate: 'このファイルは削除されました。操作できません。'
  },
  collaboratorlist: {
    set: '協働メンバーリスト'
  },
  ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER: 'このメールアドレスは既に登録済みのため、会社を作成できません。別のメールアドレスをご使用ください。',
  COOPERATOR_PERMISSION_DENIED: '協働権限がありません。',
  TEAM_SPACE_FOLDER_CREATE_NO_ADMIN: '管理層メンバー以外はチームスペースのフォルダを作成できません。',
  NOT_A_FOLDER: 'フォルダではありません。',
  FOLDER_SPACE_MISMATCH: 'フォルダのスペースが見つかりません。',
  FOLDER_DEPTH_EXCEEDED: 'フォルダ階層の上限を超えています。別のフォルダを選択してください。',
  SPACE_FOLDER_CONTAIN_SUB_FOLDER: 'このフォルダやサブフォルダへの移動ができません。',
  SPACE_FILE_ALREADY_IN_FOLDER: '既に宛先に存在します。',
  CAN_NOT_FIND_SPACE_FILE: 'このファイルは削除されました。アクセスできません。',
  SPACE_FILE_PATH_NULL: 'ファイルパスが空です。',
  COOPERATOR_ALREADY_EXISTS: '既に協働メンバーリストに存在します。追加できません。',
  INVITE_KEY_NOT_EXIST: '招待リンクが存在しません。',
  INVITE_EMAIL_ERROR: '招待メールのアドレスが正しくありません。',
  INVITE_STATUS_ERROR: '招待ステータスエラーです。',
  INVITE_STATUS_EXPIRED: '招待の有効期限が切れています。',
  INVITE_CUSTOMER_PLAN_NOT_EXIST: '招待側がサブスクリプションの購入をされていないため、ページにアクセスできません。'
}
